import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { ProductImage } from './ProductImage';
type HeroSectionProps = {
  guaranteeEnabled: boolean;
};
export function HeroSection({
  guaranteeEnabled
}: HeroSectionProps) {
  return <header className="bg-navy px-4 pb-6 pt-5 text-center md:px-10 md:pb-7 md:pt-6" data-id="element-93" data-mp="28u4ncn43lelf">
      <p className="font-heading text-[15px] font-extrabold uppercase tracking-[0.08em] text-aqua md:text-[18px]" data-id="element-94" data-mp="28vzbsbekvou9">
        AQUA CLASS HUB™
      </p>
      <h1 className="mt-1 font-heading text-[26px] font-extrabold uppercase leading-[1.06] tracking-[-0.3px] text-white md:text-[38px]" data-id="element-95" data-mp="30k984mvrs3n6">
        The complete ready-to-teach <span className="text-aqua" data-id="element-96" data-mp="2rsqrkauwvltk">aqua fitness class system</span>
      </h1>
      <p className="mx-auto mt-3 max-w-[580px] text-[14px] leading-[1.4] text-white md:text-[16px]" data-id="element-97" data-mp="2rqnsl1bs6icp">
        Stop spending hours planning your water aerobics classes. Get complete, professionally structured aqua fitness
        sessions with step-by-step exercises, exact workout timings, movement combinations, active recovery, instructor
        cues, and intensity modifications — all organized into one collection ready to use.
      </p>
      <p className="mt-2.5 font-heading text-[13px] font-extrabold uppercase leading-tight text-gold md:text-[15px]" data-id="element-98" data-mp="2p5lccev3nnye">
        Less time planning. More time teaching.
      </p>

      <div className="mx-auto mt-3 max-w-[320px]" data-id="element-99" data-mp="2z398n98ct3io">
        <ProductImage data-id="element-100" data-mp="2z1y77g2ds7uq" />
      </div>

      <p className="mx-auto mt-2 max-w-[520px] font-heading text-[13px] font-bold uppercase leading-snug text-white md:text-[15px]" data-id="element-101" data-mp="2u4etqidibz3u">
        Complete Aqua Fitness Bundle: 6 Main Volumes + 5 FREE Professional Bonuses
      </p>
      <p className="mt-1 font-heading text-[13px] font-extrabold uppercase leading-tight text-aqua md:text-[15px]" data-id="element-102" data-mp="334kztj6vlwsz">
        72 Complete Ready-to-Teach Classes + 12 Quick Workout Combos
      </p>

      <div className="mt-3.5" data-id="element-103" data-mp="18rled9fte8ds">
        <CtaButton mode="scroll" data-id="element-104" data-mp="18sd9yk9ew642">Yes! I want my classes ready to teach!</CtaButton>
      </div>
      <p className="mt-3 font-heading text-[11px] font-bold uppercase tracking-[0.12em] text-white md:text-[12px]" data-id="element-105" data-mp="38ummofnqemqp">
        Get your complete bundle today!
      </p>
      <p className="mx-auto mt-1 max-w-[440px] font-heading text-[11px] font-bold uppercase leading-snug text-white md:text-[12px]" data-id="element-106" data-mp="3iqzgren6v2lz">
        {guaranteeEnabled && <>
            <ShieldCheckIcon className="mr-1 inline h-3.5 w-3.5 -translate-y-px text-aqua" aria-hidden data-id="element-107" data-mp="3rs708ql1pyw0" />
            7-day money-back guarantee •{' '}
          </>}
        6 volumes + 5 free bonuses
      </p>
    </header>;
}